module.exports = {
    cancel: {
        all: {
            all: 'Abbrechen',
            abort: 'Abbrechen',
            refuse: 'Verwerfen',
            close: 'Schließen',
        },
    },
    abort: {
        all: {
            all: 'Abbrechen',
        },
    },
    submit: {
        all: {
            all: 'Übernehmen',
            save: 'Speichern',
            start: 'Starten',
            saveAndClose: 'Speichern & Schließen',
            create: 'Anlegen',
            duplicate: 'Duplizieren',
            generate: 'Generieren',
            export: 'Exportieren',
            select: 'Wählen',
            move: 'Verschieben',
            register: 'Anmelden',
            registerPostAuth: 'Anmeldung(en) speichern',
            ok: 'OK',
        },
        signIn: {
            all: 'Anmelden',
        },
        signUp: {
            all: 'Registrieren',
        },
        credentials: {
            showReLogin: 'Anmelden',
            showReset: 'Passwort vergessen',
            showRegister: 'Registrieren',
        },
        contact: {
            all: 'Senden',
        },
    },
    submitRefresh: {
        all: {
            all: 'Übernehmen',
            save: 'Speichern',
        },
    },
    assign: {
        all: {
            all: 'Zuweisen',
        },
        tags: {
            all: 'Tags zuweisen',
            empty: 'Tag - Zuweisung leeren',
        },
        routes: {
            all: 'Route(n) zuweisen',
            selected: 'Route(n) zuweisen (Auswahl)',
            empty: 'Routen - Zuweisung leeren',
            reset: 'Routen - Zuweisung zurücksetzen',
        },
    },
    showAssign: {
        tags: {
            all: 'Tags zuweisen',
            assignment: 'Details bearbeiten',
            management: 'Details bearbeiten',
        },
    },
    filter: {
        search: 'Suchen',
        'media-image': {
            all: 'Bild(er) verwalten',
        },
        'media-file': {
            all: 'Datei(en) verwalten',
        },
    },
    showFilter: {
        tags: {
            all: 'Tags einschränken',
            empty: 'Tag-Filter zurücksetzen',
        },
    },
    selectAll: {
        'media-image': {
            all: 'Sichtbare Bild(er) auswählen',
        },
        'media-file': {
            all: 'Sichtbare Datei(en) auswählen',
        },
        category: {
            all: 'Alle Kategorien auswählen',
        },
    },
    deselectAll: {
        'media-image': {
            all: 'Sichtbare Bild(er) abwählen',
        },
        'media-file': {
            all: 'Sichtbare Datei(en) abwählen',
        },
        category: {
            all: 'Alle Kategorien abwählen',
        },
    },
    fullScreen: {
        'media-image': {
            all: 'Vollbild-Modus',
        },
        'media-file': {
            all: 'Vollbild-Modus',
        },
    },
    closeFullScreen: {
        'media-image': {
            all: 'Vollbild-Modus beenden',
        },
        'media-file': {
            all: 'Vollbild-Modus beenden',
        },
    },
    close: {
        all: {
            all: 'Schließen',
        },
    },
    done: {
        all: {
            all: 'Schließen',
        },
    },
    edit: {
        all: {
            all: 'Bearbeiten',
        },
        categoryData: {
            asDefault: 'Als Standard',
        },
    },
    showEdit: {
        'media-image': {
            assign: 'Bild(er) zuweisen',
            assignment: 'Bild-Zuweisung bearbeiten',
        },
        tag: {
            assign: 'Tag zuweisen',
        },
        'media-file': {
            assign: 'Datei(en) zuweisen',
            assignment: 'Datei-Zuweisung bearbeiten',
        },
        tagCategoryManagement: {
            all: 'Tags verwalten',
        },
    },
    duplicate: {
        category: {
            all: 'Kategorie duplizieren',
        },
        categoryData: {
            all: 'Kategorie-Datum duplizieren',
        },
        tags: {
            all: 'Tag duplizieren',
        },
    },
    showDuplicate: {
        category: {
            all: 'Kategorie duplizieren',
        },
        categoryData: {
            all: 'Kategorie-Datum duplizieren',
        },
    },
    delete: {
        all: {
            all: 'Löschen',
        },
        category: {
            all: 'Kategorie löschen',
        },
        categoryData: {
            all: 'Kategorie-Datum löschen',
        },
        tags: {
            all: 'Tag löschen',
        },
        'media-image': {
            all: 'Bild(er) löschen',
            assignment: 'Bild-Zuweisung löschen',
            management: 'Bild löschen',
        },
        'media-file': {
            all: 'Datei(en) löschen',
            assignment: 'Datei-Zuweisung löschen',
            management: 'Datei löschen',
        },
        participant: {
            all: 'Entfernen',
        },
    },
    showSelectColumns: {
        all: {
            all: 'Spalten wählen',
        },
    },
    insert: {
        categoryData: {
            before: 'Vor diesem Kategorie-Datum',
            within: 'Kategorie-Datum hinzufügen',
            after: 'Nach diesem Kategorie-Datum',
        },
        tags: {
            all: 'Tag hinzufügen',
        },
        category: {
            root: 'Kategorie hinzufügen',
            within: 'Unter-Kategorie hinzufügen',
        },
    },
    showInsert: {
        categoryData: {
            before: 'Vor diesem Kategorie-Datum',
            within: 'Kategorie-Datum hinzufügen',
            after: 'Nach diesem Kategorie-Datum',
        },
        category: {
            root: 'Kategorie hinzufügen',
            within: 'Unter-Kategorie hinzufügen',
        },
        tagCategoryData: {
            all: 'Tag anfügen',
        },
        participant: {
            all: 'Teilnehmer hinzufügen',
        },
    },
    pause: {
        'media-image': {
            assignment: 'Bild-Zuweisung pausieren',
        },
    },
    setActive: {
        all: {
            all: 'aktivieren',
        },
    },
    setInactive: {
        all: {
            all: 'deaktivieren',
        },
    },
    reset: {
      all: {
          all: 'Rücksetzen',
      },
    },
    renew: {
        'media-image': {
            all: 'Bild(er) neu rendern',
            assignment: 'Bild neu rendern',
        },
    },
    refresh: {
        tree: {
            all: 'Neu Laden',
        },
        filter: {
            all: 'Suchen',
        },
    },
    no: {
        all: {
            all: 'Nein',
        },
        confirm: {
            all: 'Nein',
        },
    },
    yes: {
        all: {
            all: 'Ja',
        },
        confirm: {
            all: 'Ja',
        },
    },
    decisionComponent: {
        all: {
            all: 'Übernehmen',
            send: 'Senden',
            signIn: 'Anmelden',
            select: 'Wählen',
            start: 'Starten',
            generate: 'Generieren',
        },
        assign: {
            all: 'Zuweisen',
        },
        submit: {
            all: 'Speichern',
        },
        tags: {
            add: 'Anfügen',
        },
        credentials: {
            signIn: 'Anmelden',
            reset: 'Passwort zurücksetzen',
            signUp: 'Registrieren',
        },
    },
    logout: {
        all: {
            all: 'Abmelden',
        },
    },
    resetPassword: {
        all: {
            all: 'Passwort setzen',
        },
        user: {
            all: 'Passwort setzen',
        },
    },
    showReLogin: {
        credentials: {
            all: 'Anmelden',
        },
    },
    showRegister: {
        credentials: {
            all: 'Registrieren',
        },
    },
    showReset: {
        credentials: {
            all: 'Passwort vergessen',
        },
    },
    showExport: {
        all: {
            all: 'Export',
        },
        component: {
            all: 'Export',
        },
        category: {
            all: 'Export',
        },
    },
    download: {
        all: {
            all: 'Herunterladen',
        },
        'media-file': {
            management: 'Herunterladen',
            assignment: 'Herunterladen',
        },
    },
    showImport: {
        all: {
            all: 'Importieren',
        },
    },
    showPreview: {
        all: {
            all: 'Vorschau',
        },
    },
    upload: {
        image: 'Bild(er) hochladen',
        file: 'Datei(en) hochladen',
        tagged: {
            image: 'Bild(er) mit Tags hochladen',
            file: 'Datei(en) mit Tags hochladen',
        },
    },
    lazyload: {
        images: {
            all: 'Weitere Bilder laden',
        },
        files: {
            all: 'Weitere Dateien laden',
        },
    },
    tagConnection: {
        and: 'Und',
        or: 'Oder',
    },
    send: {
        all: {
            all: 'Senden',
        },
    },
    resend: {
        all: {
            all: 'Erneut Senden',
        },
        mailing: {
            all: 'Nachsenden',
        },
    },
    schedule: {
        all: {
            all: 'Einreihen',
        },
    },
    unschedule: {
        all: {
            all: 'Ausreihen',
        },
    },
    copyToClipboard: {
        all: {
            all: 'In die Zwischenablage kopieren',
            link: 'Link in die Zwischenablage kopieren',
        },
        text: {
            all: 'In die Zwischenablage kopieren',
        },
        textarea: {
            all: 'In die Zwischenablage kopieren',
        },
    },
    copyToClipboardUrl: {
        all: {
            all: 'Link in die Zwischenablage kopieren',
        },
        'media-image': {
            all: 'Link in die Zwischenablage kopieren',
            management: 'Link in die Zwischenablage kopieren',
            assignment: 'Link in die Zwischenablage kopieren',
        },
        'media-file': {
            all: 'Link in die Zwischenablage kopieren',
            management: 'Link in die Zwischenablage kopieren',
            assignment: 'Link in die Zwischenablage kopieren',
        },
    },
    open: {
        all: {
            all: 'Link öffnen',
        },
        routes: {
            all: 'Route öffnen',
        },
        'media-image': {
            all: 'Bild öffnen',
            assignment: 'Bild öffnen',
        },
        'media-file': {
            all: 'Datei öffnen',
            assignment: 'Datei öffnen',
        },
    },
    tel: {
        all: {
            all: 'anrufen',
        },
    },
    mail: {
        all: {
            all: 'schreiben',
        },
    },
    view: {
        all: {
            all: 'Öffnen',
            link: 'Link öffnen',
        },
    },
    showFullText: {
        all: {
            all: 'Vollständigen Text anzeigen',
        },
    },
    generate: {
        text: {
            all: 'Generieren',
        },
    },
}